/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// INTERFACES
import {
  Line,
  PlanDetailsResponse,
  PlanOption,
} from '@support/api/proxies/responses/api-2123.interface';

export class PlanDetailsCategoryModel {
  /**
   * To store description of selected plan
   */
  public description: string;
  /**
   * To store family name of selected plan
   */
  public familyName: string;
  /**
   * To store family code of selected plan
   */
  public familyCode: string;
  /**
   * To store family code of selected plan
   */
  public legalText: string;
  /**
   * To store plan details response
   */
  public category: PlanDetailsResponse;

  public planOptions: PlanOption[];

  constructor(response: PlanDetailsResponse, isAssisted?: boolean) {
    if (response && response.family && response.family[0]) {
      this.planOptions = [];
      const familyName = response.family[0].familyName;
      const description = response.family[0].familyDescription;
      const familyCode = response.family[0].familyCode;
      response.family[0].plans.lines.forEach((plans: Line) => {
        this.planOptions = plans.planOptions;
      });
      this.setFamilyName(familyName);
      this.setFamilyCode(familyCode);
      this.setCategoryDescription(description);
    } else {
      this.category = null;
    }
  }

  /**
   * To set Plan Family code
   * @returns void
   */
  private setFamilyCode(familyCode: string): void {
    if (familyCode) {
      this.familyCode = familyCode;
    } else {
      this.familyCode = '';
    }
  }

  /**
   * To get Plan Family code
   * @returns string
   */
  public getFamilyCode(): string {
    return this.familyCode;
  }

  /**
   * To get Plan Family Name
   * @returns string
   */
  public getFamilyName(): string {
    return this.familyName;
  }

  /**
   * To set family name
   * @returns void
   */
  private setFamilyName(familyName: string): void {
    if (familyName) {
      this.familyName = familyName;
    } else {
      this.familyName = '';
    }
  }

  /**
   * To get Plan Family Description
   * @returns string
   */
  private setCategoryDescription(description: string): void {
    if (description) {
      this.description = description;
    } else {
      this.description = '';
    }
  }

  /**
   * To get Plan Family Category
   * @returns Category
   */
  public getCategoryDescription(): string {
    return this.description;
  }

  /**
   * To get Line In Focus
   * @param lineId of type string
   * @returns Line
   */
  public getLineInFocus(lineId: string): Line {
    if (
      this.category[0].family[0] &&
      this.category[0].family[0].plans.lines &&
      this.category[0].family[0].plans.lines.length
    ) {
      return this.getLine(this.category[0].family[0].plans.lines, lineId);
    } else {
      return null;
    }
  }

  /**
   * To filter Line In Focus
   * @param lines of type Line[]
   * @param lineId of type string
   * @returns Line
   */
  private getLine(lines: Line[], lineId: string): Line {
    const lineInFocus = lines.find((line: Line) => {
      return line.lineId === lineId;
    });
    if (lineInFocus) {
      return lineInFocus;
    } else if (!lineInFocus && lines && lines.length) {
      return lines[0];
    } else {
      return null;
    }
  }
}
